
import { Box, Typography } from "@mui/material";
import NotFoundImage from "../../src/assets/notImage.png"
import {palette, theme as colorTheme } from "../Convoze.theme"
import { color } from "echarts";


function NoData() {

  const primary = colorTheme('palette', 'primary').value;

  return (
    <Box
      sx={{
  
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        overflow: "hidden",
        borderRadius:5,
        height:"55vh"
      }}
    >
      <Box
        sx={{
      

          borderRadius: 4,
          px: { xs: 4, sm: 5 },
          py: 5,
          textAlign: "center",
          maxWidth: 420,
          width: "100%",
        }}
      >
        <Box
          component="img"
          src={NotFoundImage}
          sx={{
            width: { xs: 120, sm: 140 },
            height: "auto",
            mx: "auto",
            // mb: 1,
            borderRadius: 3,
          }}
        />

        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#1f2937", mb: 1, letterSpacing: 0.5 }}
        >
          No results found
        </Typography>

        <Typography variant="body2" sx={{ color: "#4b5563", maxWidth: 260, mx: "auto" }}>
          try a different word or filter or 
          <Box component="span" sx={{ color: primary, fontWeight: 600 }}>
            {" search again."}
            
          </Box>
        </Typography>
      </Box>
      
    </Box>
  );
}

export default NoData;